( function () {
	'use strict';

	function editschedservice ( $modal, $filter, moment, scheduleservice, Session ) {
		function openModal ( event ) {
			function displayModal () {
				$modal.open( {
					'templateUrl'  : '/templates/schedules/edit-schedule/edit-schedule-modal.html',
					'controller'   : 'EditScheduleModal',
					'controllerAs' : 'vm',
					'keyboard'     : false,
					'backdrop'     : 'static',
					'resolve'      : {
						'eventModel' : function () {
							return event;
						}
					}
				} );
			}

			function getObservationDetails () {
				scheduleservice.getObservation( event ).then( function ( res ) {
					var templateId = res.template.id;

					event.meta = {
						'templateId' : templateId,
						'observee'   : [ event.observee.id ],
						'observer'   : [ event.observer.id ]
					};

					event.isInProgress = true;

					if ( !event.endDate ) {
						event.endDate = moment().format( 'YYYY-MM-DD HH:mm Z' ).toString();
					}

					displayModal();
				} );
			}

			if ( event.meta ) {
				displayModal();
			} else {
				getObservationDetails();
			}
		}

		function getLocation ( schools, observeeId ) {
			return $filter( 'filter' )( schools, function ( school ) {
				var selectedUser = $filter( 'filter' )( school.users || [ ], function ( user ) {
					return user.PersonnelId === observeeId;
				} )[ 0 ];

				if ( selectedUser ) {
					return selectedUser.PersonnelId === observeeId;
				}
			} )[ 0 ];
		}

		function getObservee ( schools, observeeId ) {
			if ( getLocation( schools, observeeId ) ) {
				return $filter( 'filter' )( getLocation( schools, observeeId ).users, function ( user ) {
					return user.PersonnelId === observeeId;
				} )[ 0 ];
			}
		}

		function getTemplate ( templates, templateId ) {
			return $filter( 'filter' )( templates, function ( template ) {
				return template.id === templateId;
			} )[ 0 ];
		}

		function getEventDate ( date ) {
			return moment( date ).format( 'YYYY-MM-D' );
		}

		function incorrectEndTime ( schedule ) {
			var startDate = moment( schedule.eventDate ).format( 'MM/DD/YYYY' ) + ' ' + moment( schedule.startTime ).format( 'h:mm a' );
			var endDate   = moment( schedule.endDate ).format( 'MM/DD/YYYY' ) + ' ' + moment( schedule.endTime ).format( 'h:mm a' );

			return moment( endDate ).format( 'x' ) <= moment( startDate ).format( 'x' ) || moment( endDate ).format( 'x' ) <= moment().format( 'x' );
		}

		function getStartTime ( date ) {
			return moment( date ).format();
		}

		function getEndTime ( date ) {
			return moment( date ).add( 1, 'h' ).format();
		}

		function getSelectedByPointer ( selections, pointer ) {
			return $filter( 'filter' )( selections, function ( selection ) {
				return selection.pointer === pointer;
			} );
		}

		function saveScheduleChanges ( schedule ) {
			var update = null;

			if ( !schedule.isInProgress ) {
				update = scheduleservice.updateSchedule( schedule );
			} else {
				update = scheduleservice.updateObservation( schedule );
			}

			return update;
		}

		function isOnGoing ( eventDate, startTime, endTime ) {
			var startDate = moment( scheduleservice.getScheduledDate( eventDate, startTime ) );
			var endDate   = moment( scheduleservice.getScheduledDate( eventDate, endTime ) );
			var dateNow   = moment();

			if ( startDate.format( 'YYMMD' ) === dateNow.format( 'YYMMD' ) ) {
				if ( dateNow.format( 'HHmm' ) >= startDate.format( 'HHmm' ) && dateNow.format( 'HHmm' ) <= endDate.format( 'HHmm' ) ) {
					return true;
				}
			}

			return false;
		}

		return {
			'openModal'             : openModal,
			'isPastEvent'           : scheduleservice.isPastEvent,
			'getSessionCredentials' : Session.getCredentials,
			'getLocation'           : getLocation,
			'getObservee'           : getObservee,
			'getTemplate'           : getTemplate,
			'getEventDate'          : getEventDate,
			'incorrectEndTime'      : incorrectEndTime,
			'getStartTime'          : getStartTime,
			'getEndTime'            : getEndTime,
			'getSelectedByPointer'  : getSelectedByPointer,
			'saveScheduleChanges'   : saveScheduleChanges,
			'isOnGoing'             : isOnGoing
		};
	}

	angular
		.module( 'app.schedules' )
		.factory( 'editschedservice', editschedservice );

	editschedservice.$inject = [ '$modal', '$filter', 'moment', 'scheduleservice', 'Session' ];
} )( );
